import React from 'react';
import { useCookies } from 'react-cookie';

import { useSnackbar } from 'notistack';

import { useSetUserAuth } from '@/state/cookieContext';

import { useInitializeAclosetRemoteConfig } from './metadata/hooks/use-acloset-remote-config';

export const AppInitializeProvider = ({ children }: { children: React.ReactNode }) => {
  const isCookieMigrationDone = useCookieMigration();
  const isLoadedBeforeLogin = useInitEffectBeforeLogin(true);

  const appAvailable = isLoadedBeforeLogin && isCookieMigrationDone;

  if (appAvailable) {
    return children;
  } else {
    return null;
  }
};

/**
 * 로그인 전 초기화 이펙트.
 */
const useInitEffectBeforeLogin = (networkConnected: boolean) => {
  const { isPending: remoteConfigIsPending, isSuccess: remoteConfigIsSuccess } =
    useInitializeAclosetRemoteConfig(networkConnected);

  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    const failed = !remoteConfigIsPending && !remoteConfigIsSuccess;

    if (failed) {
      enqueueSnackbar({
        variant: 'error',
        message:
          '웹 시작에 필요한 정보를 받아오지 못했습니다.\n잠시 후 다시 시도하거나, 인터넷 연결을 확인해주세요.\n만일, 지속적으로 발생 시 문의 부탁드립니다.',
      });
    }
  }, [enqueueSnackbar, remoteConfigIsPending, remoteConfigIsSuccess]);

  return remoteConfigIsSuccess;
};

const useCookieMigration = () => {
  const [cookies, setCookies, removeCookies] = useCookies(['userAuthContext']);

  const [done, setDone] = React.useState(cookies.userAuthContext == null);

  const setUserAuth = useSetUserAuth();

  React.useEffect(() => {
    if (cookies.userAuthContext != null) {
      setUserAuth(cookies.userAuthContext);
      removeCookies('userAuthContext');
    }
    setDone(true);
  }, [cookies, removeCookies, setUserAuth]);

  return done;
};
